//async
export const GET_PARKING_LIST_REQUEST = '[PARKING] GET_PARKING_LIST_REQUEST';
export const GET_PARKING_LIST_SUCCESS = '[PARKING] GET_PARKING_LIST_SUCCESS';
export const GET_PARKING_LIST_FAILED = '[PARKING] GET_PARKING_LIST_FAILED';

export const LOAD_PARKING_DATA_REQUEST = '[PARKING] LOAD_PARKING_DATA_REQUEST';
export const LOAD_PARKING_DATA_SUCCESS = '[PARKING] LOAD_PARKING_DATA_SUCCESS';
export const LOAD_PARKING_DATA_FAILED = '[PARKING] LOAD_PARKING_DATA_FAILED';

export const LOAD_PARKING_SPOTS_TABLE_DATA_REQUEST = '[PARKING] LOAD_PARKING_SPOTS_TABLE_DATA_REQUEST';
export const LOAD_PARKING_SPOTS_TABLE_DATA_SUCCESS = '[PARKING] LOAD_PARKING_SPOTS_TABLE_DATA_SUCCESS';
export const LOAD_PARKING_SPOTS_TABLE_DATA_FAILED = '[PARKING] LOAD_PARKING_SPOTS_TABLE_DATA_FAILED';

export const LOAD_PARKING_SPOTS_GRAPH_DATA_REQUEST = '[PARKING] LOAD_PARKING_SPOTS_GRAPH_DATA_REQUEST';
export const LOAD_PARKING_SPOTS_GRAPH_DATA_SUCCESS = '[PARKING] LOAD_PARKING_SPOTS_GRAPH_DATA_SUCCESS';
export const LOAD_PARKING_SPOTS_GRAPH_DATA_FAILED = '[PARKING] LOAD_PARKING_SPOTS_GRAPH_DATA_FAILED';

export const LOAD_SEARCH_FIELDS_DATA_REQUEST = '[PARKING] LOAD_SEARCH_FIELDS_DATA_REQUEST';
export const LOAD_SEARCH_FIELDS_DATA_SUCCESS = '[PARKING] LOAD_SEARCH_FIELDS_DATA_SUCCESS';
export const LOAD_SEARCH_FIELDS_DATA_FAILED = '[PARKING] LOAD_SEARCH_FIELDS_DATA_FAILED';

export const CHANGE_SPOT_CATEGORY_REQUEST = '[PARKING] CHANGE_SPOT_CATEGORY_REQUEST';
export const CHANGE_SPOT_CATEGORY_SUCCESS = '[PARKING] CHANGE_SPOT_CATEGORY_SUCCESS';
export const CHANGE_SPOT_CATEGORY_FAILED = '[PARKING] CHANGE_SPOT_CATEGORY_FAILED';


//reducer only
export const RESET_SELECTED_PARKING = '[PARKING] RESET_SELECTED_PARKING';

export const COLLAPSE_SPOTS_INFO_CATEGORIES = '[PARKING] COLLAPSE_SPOTS_INFO_CATEGORIES';

export const TABLE_SEARCH_FIELD_CHANGED = '[PARKING] TABLE_SEARCH_FIELD_CHANGED';
export const TABLE_SEARCH_FIELD_CLEAN_ALL = '[PARKING] TABLE_SEARCH_FIELD_CLEAN_ALL';

export const GRAPH_SEARCH_FIELD_CHANGED = '[PARKING] GRAPH_SEARCH_FIELD_CHANGED';
export const GRAPH_SEARCH_FIELD_CLEAN_ALL = '[PARKING] GRAPH_SEARCH_FIELD_CLEAN_ALL';

export const OPEN_SPOT_CONFIGURATION_MODAL = '[PARKING] OPEN_SPOT_CONFIGURATION_MODAL';
export const CLOSE_SPOT_CONFIGURATION_MODAL = '[PARKING] CLOSE_SPOT_CONFIGURATION_MODAL';
export const CHANGE_SELECTED_CATEGORY = '[PARKING] CHANGE_SELECTED_CATEGORY';

